import { Database } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { dbExplorerWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  dbExplorerWeb,
  {
    DatabasePage: () => import('./DatabasePage'),
  },
  {
    icons: { Database },
  },
);
